// The carriers' names as people read them — ONE copy for the frontend (Fernando, 2026-10-02: "Bring, DPD,
// Omniva, Packeta, Posti"; the carrier we contract, never its partner). The backend's twin is
// backend/parcel_report.py CARRIER_NAME (and main.py CARRIER_DISPLAY for the order grid).
import React from 'react';

export const CARRIER_NAME: Record<string, string> = {
  bring: 'Bring', dpd_baltics: 'DPD', omniva: 'Omniva', packeta: 'Packeta', posti: 'Posti',
};
export const CARRIER_CODES = Object.keys(CARRIER_NAME);

export const carrierName = (code?: string | null) => (code ? CARRIER_NAME[code] || code : '');

/** A tracking number that opens the carrier's public tracking page (the link a customer can be sent). */
export function TrackLink({ num, url }: { num?: string | null; url?: string | null }) {
  if (!num) return null;
  if (!url) return <span className="font-mono">{num}</span>;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}
       className="font-mono text-blue-400 hover:text-blue-300" title="Open the carrier's tracking page">
      {num} ↗
    </a>
  );
}
